interface MetricCardProps {
  label: string
  value: number | string | null
  isLoading?: boolean
  isError?: boolean
}

export function MetricCard({ label, value, isLoading, isError }: MetricCardProps) {
  const displayValue = isError ? 'Error' : isLoading ? '...' : value ?? 'N/A'

  return (
    <div className="relative overflow-hidden rounded-lg border border-white/[0.06] bg-white/[0.02] p-4 transition-all duration-200 hover:border-white/[0.1] hover:bg-white/[0.03]">
      <div className="text-xs font-semibold text-white/70 uppercase tracking-wider mb-3">{label}</div>

      {isLoading ? (
        <div className="h-10 w-20 bg-white/[0.02] rounded animate-pulse" />
      ) : (
        <div className="text-4xl font-bold text-white tabular-nums">{displayValue}</div>
      )}
    </div>
  )
}
